"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColorPicker;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactColor = require("react-color");
var _common = require("react-color/lib/components/common");
var _reactIntl = require("react-intl");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    checkboard: {
      borderRadius: theme.shape.borderRadius
    },
    color: {
      borderRadius: theme.shape.borderRadius,
      bottom: 0,
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    },
    colorButton: {
      backgroundColor: 'unset !important',
      border: "1px solid ".concat(theme.palette.grey[400]),
      borderRadius: 5,
      height: 49,
      marginRight: theme.spacing(1),
      minWidth: 1,
      width: 49
    },
    root: {
      alignItems: 'flex-start',
      display: 'flex'
    }
  };
});
function ColorPicker(_ref) {
  var className = _ref.className,
    defaultValue = _ref.defaultValue,
    disableAlpha = _ref.disableAlpha,
    labelKey = _ref.labelKey,
    id = _ref.id,
    _onChange = _ref.onChange,
    value = _ref.value;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    displayColorPicker = _useState2[0],
    setDisplayColorPicker = _useState2[1];
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
    setDisplayColorPicker(!displayColorPicker);
  }
  function handleClose() {
    setAnchorEl(null);
    setDisplayColorPicker(false);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.colorButton,
    id: "".concat(id, "TogglePickerButton"),
    onClick: function onClick(e) {
      return handleClick(e);
    },
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_common.Checkboard, {
    className: classes.checkboard
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.color,
    style: {
      backgroundColor: value || defaultValue
    }
  })), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "".concat(id, "Field"),
    InputLabelProps: {
      shrink: true
    },
    label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: labelKey
    }),
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    placeholder: defaultValue,
    value: value,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_material.Popover, {
    anchorEl: anchorEl,
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    id: "".concat(id, "Picker"),
    onClose: function onClose() {
      return handleClose();
    },
    open: displayColorPicker,
    transformOrigin: {
      horizontal: 'left',
      vertical: 'top'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactColor.ChromePicker, {
    color: value || defaultValue,
    disableAlpha: !!disableAlpha,
    onChange: function onChange(val) {
      return _onChange(val.rgb.a === 1 || disableAlpha === true || Object.keys(val.rgb).filter(function (k) {
        return val.rgb[k] === 0;
      }).length === 4 ? val.hex : "rgba(".concat(val.rgb.r, ", ").concat(val.rgb.g, ", ").concat(val.rgb.b, ", ").concat(val.rgb.a, ")"));
    }
  })));
}